import { sagas as clientSettingsSagas } from '../modules/ClientSettings/store/sagas'
import { sagas as clientvisibilitySagas } from '../modules/ClientVisibility/store/sagas'
import { sagas as paymentApproversSagas } from '../modules/PaymentApprovers/store/sagas'

export const modulesSagas = [
  ...clientvisibilitySagas,
  ...clientSettingsSagas,
  ...paymentApproversSagas
]
